<ng-container *transloco="let convert;">
  <button
    data-testid="bidlist-status-filter-all-button"
    id="all-button"
    data-selected-button="FilterAll"
    data-track-elem="button"
    data-track-name="Filter_all"
    class="bg-secondary tab"
    [ngClass]="{active: isActiveFilter(ALL)}"
    (click)="filterByStatus(ALL)"
  >
  {{ convert('vehicles.bidListFilter.bidListStatusFilter.btnAll') }} ({{ bidListStatusCounts.allItemsCount }})
  </button>

  <button
    data-testid="bidlist-status-filter-won-button"
    id="won-button"
    data-selected-button="FilterWon"
    data-track-elem="button"
    data-track-name="Filter_won"
    class="bg-secondary tab"
    [ngClass]="{active: isActiveFilter(WON)}"
    (click)="filterByStatus(WON)"
  >
  {{ convert('vehicles.bidListFilter.bidListStatusFilter.btnWon') }} ({{ bidListStatusCounts.wonItemsCount }})
  </button>

  <button
    data-testid="bidlist-status-filter-leading-button"
    id="leading-button"
    data-selected-button="FilterLeading"
    data-track-elem="button"
    data-track-name="Filter_leading"
    class="bg-secondary tab"
    [ngClass]="{active: isActiveFilter(LEADING)}"
    (click)="filterByStatus(LEADING)"
  >
  {{ convert('vehicles.bidListFilter.bidListStatusFilter.btnLeading') }} ({{ bidListStatusCounts.leadingItemsCount }})
  </button>

  <button
    data-testid="bidlist-status-filter-outbid-button"
    id="outbid-button"
    data-selected-button="FilterOutbid"
    data-track-elem="button"
    data-track-name="Filter_outbid"
    class="bg-secondary tab"
    [ngClass]="{active: isActiveFilter(OUTBID)}"
    (click)="filterByStatus(OUTBID)"
  >
  {{ convert('vehicles.bidListFilter.bidListStatusFilter.btnOutbid') }} ({{ bidListStatusCounts.outbidItemsCount }})
  </button>

  <button
    data-testid="bidlist-status-filter-offer-button"
    id="offer-button"
    data-selected-button="FilterOffer"
    data-track-elem="button"
    data-track-name="Filter_offer"
    class="bg-secondary tab"
    [ngClass]="{active: isActiveFilter(OFFER)}"
    (click)="filterByStatus(OFFER)"
  >
  {{ convert('vehicles.bidListFilter.bidListStatusFilter.btnOffers') }} ({{ bidListStatusCounts.offersItemsCount }})
  </button>

</ng-container>
